<template>
  <div
    class="lav-card__cta-wrapper"
    data-cy="counselor-card-cta"
    :class="{ 'lav-card__phone-wrapper': showPhoneNumber }"
  >
    <a
      class="btn btn-cta btn-phone-cta"
      v-if="showPhoneNumber"
      ref="phoneWrapper"
      :href="phoneNumberTel"
      @click="gtmPhoneCallTrigger($event, `Advisor slider - ${counselor.name}`)"
    >
      <svg class="icon">
        <use href="#phone" />
      </svg>
      <span v-html="phoneText" />
    </a>
    <a
      class="counselor-card__cta btn btn-cta icon-left"
      v-else-if="isTherapist && link !== '#'"
      :href="link"
      v-text="texts.readMoreAndBook"
    />
    <a
      class="btn btn-cta small counselor-card__cta"
      v-else-if="link !== '#'"
      :href="link"
    >
      {{ texts.readMoreAndBook }}
    </a>
  </div>
</template>

<script>
import { usePhoneNumber } from 'Main/composables/usePhoneNumber';
import { sprintf } from 'sprintf-js';

export default {

  computed: {
    phoneText() {
      return sprintf(
        this.texts.call,
        `<span class="lav-card__phone-number">${this.phoneNumber}</span>`
      );
    },
  },

  data() {
    const showPhoneNumber = this.isLawyer
      ? theme_vars.localConfig.showLawCounselorCardPhoneNumber
      : theme_vars.localConfig.showCounselorCardPhoneNumber;

    return {
      showPhoneNumber,
      texts: theme_vars.counselorSlider,
    };
  },

  mounted() {
    if (this.showPhoneNumber) {
      // Wait for the phone number to be loaded in the DOM
      this.$nextTick(() => {
        this.ctmInit(this.$refs.phoneWrapper);
      });
    }
  },
  name: 'CounselorCardCta',

  props: {
    counselor: {
      required: true,
      type: Object,
    },
    isLawyer: {
      default: false,
      type: Boolean,
    },
    isTherapist: {
      default: false,
      type: Boolean,
    },
    link: {
      required: true,
      type: String,
    },
  },

  setup() {
    const {
      phoneNumber,
      phoneNumberTel,
      hidePhoneNumber,
      isTherapyPage,
      countryPhoneCode,
      maybeUpdatePhoneNumber,
      updatePhoneNumber,
      ctmRunNow,
      ctmInit,
      gtmPhoneCallTrigger,
    } = usePhoneNumber();
    return {
      countryPhoneCode,
      ctmInit,
      ctmRunNow,
      gtmPhoneCallTrigger,
      hidePhoneNumber,
      isTherapyPage,
      maybeUpdatePhoneNumber,
      phoneNumber,
      phoneNumberTel,
      updatePhoneNumber,
    };
  },
};
</script>
